import { __assign, __spreadArrays } from "tslib";
import { Message } from '@wix/chat-sdk';
export var appendDataToMessage = function (message, newData) {
    return new Message(__assign(__assign({}, message.dto), { data: __spreadArrays(message.dto.data, newData) }), message.transit, message.indications, message.groupPosition, message.showSentTime);
};
//# sourceMappingURL=messageHelpers.js.map